export default __webpack_public_path__ + "static/media/washerfluid-3b.025b4747.jpg";